// extracted by mini-css-extract-plugin
export var layoutContainer = "_dz-0";
export var layoutContainerNoRounding = "_dz-6";
export var layoutContainerOpen = "_dz-5";
export var layoutContainerResizing = "_dz-1";
export var mainContent = "_dz-2";
export var resizeDivider = "_dz-3";
export var slidePanel = "_dz-4";